/* ============================================================
   AK Homepage Letters — curated testimonial rotator

   Each [data-letters-home] block contains a stack of curated
   customer Letters (.v3home-letters__item). This picks a random
   one to start, and — when data-rotate="true" — quietly
   auto-advances through them on a fade, pausing on hover.

   Server render marks the first item .is-active so the section
   is fully visible with no JS; this script only swaps which one
   shows. A block with a single Letter does nothing.
   ============================================================ */
(function () {
  if (window.__akHomeLettersInit) return;
  window.__akHomeLettersInit = true;

  function initOne(root) {
    var items = root.querySelectorAll('.v3home-letters__item');
    if (items.length <= 1) return;

    var rotate = root.getAttribute('data-rotate') === 'true';
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 7000;

    function show(idx) {
      for (var i = 0; i < items.length; i++) {
        items[i].classList.toggle('is-active', i === idx);
      }
    }

    var current = Math.floor(Math.random() * items.length);
    show(current);

    if (!rotate) return;

    var timer = null;
    function advance() {
      current = (current + 1) % items.length;
      show(current);
    }
    function start() { timer = window.setInterval(advance, interval); }
    function stop() { if (timer) { window.clearInterval(timer); timer = null; } }

    start();
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else if (!timer) start();
    });
  }

  function init() {
    var blocks = document.querySelectorAll('.v3home-letters[data-letters-home]');
    Array.prototype.forEach.call(blocks, initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
